/* eslint-disable */
(function() {
  'use strict';

  var $ = require('jquery');

  var self = {
    BasketPopup: BasketPopup,
    UpdateTopBasket: UpdateTopBasket,
  };

  // Expose globally for legacy calls.
  window.BasketPopup = BasketPopup;
  window.UpdateTopBasket = UpdateTopBasket;

  /** Show basket pop up. */
  function BasketPopup(popup, message, viewBasketText) {
    var $popup = popup;

    if (viewBasketText.length > 0) {
      message =
        message +
        "<br /><a href='/enquiry/'><span class='basket-icon'><i class='fa fa-shopping-cart'></i></span>" +
        viewBasketText +
        '</a>';
    }

    $popup.find('.message').html(message);
    $popup.fadeIn(500, function() {
      $popup.delay(3000).fadeOut(500);
    });
  }

  /** Update basket preview count. */
  function UpdateTopBasket(itemCount) {
    $('.basket-count').html(itemCount);
    $('.basket-area .number').html('(' + itemCount + ')');
  }

  module.exports = self;
})();
